import { api } from "constants/RotasAPI";
import usePost from "hooks/usePost";
import { toast } from "react-hot-toast";
import { queryClient } from "shared/util/queryClient";
import { ConfigurarGroupPayRequest } from "types/request/groupPay/ConfigurarGroupPayRequest";

type UseConfigurarGroupPayOptions = {
  successMessage?: string | JSX.Element;
};

export const usePostConfigurarGroupPay = (options: UseConfigurarGroupPayOptions) => {
  const {successMessage} = options;
  const onSuccess = () => {
    if (successMessage) toast.success(successMessage);
    queryClient.invalidateQueries("tabela-condominios-group-pay");
  };

  return usePost<ConfigurarGroupPayRequest>({
    url: api.groupPay.postConfigurarGroupPay,
    onSuccess,
  });
};
 